import type { SVGProps } from 'react';

export const Undo = (props: SVGProps<any>) => (
  <svg
    height="18px"
    version="1.1"
    viewBox="0 0 18 18"
    width="18px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'undo block availability'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-51, -176)">
        <g transform="translate(27, 56)">
          <g transform="translate(24, 120)">
            <rect height="18" width="18" x="0" y="0"></rect>
            <g
              fill="#3D57FF"
              fillRule="nonzero"
              transform="translate(0.1469, 1.4797)"
            >
              <path d="M10.2122449,0 C6.42857143,0 3.30612245,2.79183673 2.79183673,6.42857143 L0,6.06122449 L3.80204082,12.3979592 L7.5122449,6.06122449 L4.90408163,6.41020408 C5.41836735,3.93061224 7.60408163,2.0755102 10.2306122,2.0755102 C13.2061224,2.0755102 15.6489796,4.51836735 15.6489796,7.5122449 C15.6489796,10.5061224 13.2061224,12.9489796 10.2122449,12.9489796 L10.2122449,15.0244898 C14.344898,15.0244898 17.7244898,11.6632653 17.7244898,7.5122449 C17.7244898,3.36122449 14.3632653,0 10.2122449,0 Z"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
